window.DDIGITAL = window.DDIGITAL || {};
DDIGITAL.IS_RESPONSIVE = true;
DDIGITAL.IS_EDIT = DDIGITAL.IS_EDIT || false;

(function(NAMESPACE, $) {

	'use strict';

	/* Stop console.log errors */
	if (typeof console === 'undefined') {
		window.console = {};
		console.log = console.error = console.info = console.debug = console.warn = console.trace = console.dir = console.dirxml = console.group = console.groupEnd = console.time = console.timeEnd = console.assert = console.profile = console.table = function() {};
	}

	// Overrides for the default breakpoints in the DDBreakpoints SCSS Mixin and
	// JavaScript library.
	// TODO: Remove the below section if the defaults are unchanged.
	DD.bp.options({
		breakpoints: [
			{name: 'xxs', px: 359},
			{name: 'xs', px: 480},
			{name: 's', px: 640},
			{name: 'm', px: 768},
			{name: 'l', px: 1024},
			{name: 'xl', px: 1272},
			{name: 'xxl', px: 1272}
		]
	});

	var $defaultScope = $('body');

	NAMESPACE.INIT = {
		visual: function($scope) {
			$scope = $scope || $defaultScope;

			NAMESPACE.contentModules.init();

			NAMESPACE.util.helpers.init();
			NAMESPACE.util.device.init();

			NAMESPACE.navOffscreen.init();
			NAMESPACE.navOnscreen.init();

			NAMESPACE.expandCollapse.init($scope);
			NAMESPACE.modal.init();
			NAMESPACE.horizontalFilterBarModal.init();
			NAMESPACE.tooltip.init();

			NAMESPACE.carousel.init();

			NAMESPACE.tabs.init();
			NAMESPACE.contactTiles.init();
			NAMESPACE.micrositeHeroBanner.init();
			NAMESPACE.feedbackFormPage.init();

			if (!NAMESPACE.IS_EDIT) {
				NAMESPACE.linkIcons.init();
			}

			if (!NAMESPACE.IS_EDIT) {
				NAMESPACE.responsiveTable.init();
			}

			NAMESPACE.doWhen.init();

			NAMESPACE.video.init();
			NAMESPACE.bgVideo.init();
			NAMESPACE.map.init();

			NAMESPACE.equalHeights.init($scope);

			NAMESPACE.globalHeader.init();

			NAMESPACE.homepageUserTaskNav.init($scope);

			NAMESPACE.responsiveLayout.init();

			NAMESPACE.responsiveIframe.init();
			NAMESPACE.EmergencyBanner.init();
		},
		functional: function($scope) {
			$scope = $scope || $defaultScope;

			NAMESPACE.forms.validate.init($scope);
			NAMESPACE.forms.sync.init();
			NAMESPACE.forms.multiStep.init($scope);

			NAMESPACE.contactUsForm.init();

			NAMESPACE.togglePopover.init();
			NAMESPACE.autocomplete.init();

			NAMESPACE.util.print.init();
			NAMESPACE.util.scroll.init();

			NAMESPACE.providerSearchSegCtrl.init();

			NAMESPACE.search.init();

			NAMESPACE.util.googleMapUtil.init();

			NAMESPACE.a11ySettingsPage.init();

			// if you need the shade to slide with the page
			// (e.g. if the page uses the offscreen nav in "side" position)
			// put the shade inside the '.page-wrap' instead
			$('.page-wrap').ddShade();

			NAMESPACE.buildInfo.init();

			if (NAMESPACE.IS_EDIT) {
				$('html').addClass('is-edit');
			}

			NAMESPACE.eventConstructorsPolyfill.init();
			NAMESPACE.multilingualPanel.init();
			NAMESPACE.mobileMultilingualModal.init();
			NAMESPACE.readSpeakerHandler.init();
		}
	};

	NAMESPACE.init = function() {
		NAMESPACE.INIT.visual();
		NAMESPACE.INIT.functional();
		NAMESPACE.triggerReady();

		// Any DOM element can trigger the 're-init-all' event to have all modules re-initialise
		$(window.document)
			.on('re-init-all', function(evt) {
				var $scope = $(evt.target);

				NAMESPACE.INIT.visual($scope);
				NAMESPACE.INIT.functional($scope);
			});
	};

	$(document).ready(function() {
		NAMESPACE.init();
	});

	// Capture window load (not DOM ready) and inject ID to google translate dropdown
	$(window).load(function() {
		if (window.addIdToGoogleTranslateElement && typeof window.addIdToGoogleTranslateElement === 'function') {
			window.addIdToGoogleTranslateElement();
		}
	});

}(DDIGITAL, jQuery));


require('./util/_buildInfo.js');
require('./util/_device.js');
require('./util/_formatter.js');
require('./util/_googleMapsUtil.js');
require('./util/_helpers.js');
require('./util/_print.js');
require('./util/_scroll.js');


require('./modules/_a11ySettingsPage');
require('./modules/_analyticsPortal');
require('./modules/_autocomplete');
require('./modules/_bgVideo');
require('./modules/_carousel');
require('./modules/_cm32-provider-search-sgt-ctrl');
require('./modules/_cm54-emergency-banner');
require('./modules/_contactTiles');
require('./modules/_contentModules');
require('./modules/_doWhen');
require('./modules/_equalHeights');
require('./modules/_event-constructors-polyfill');
require('./modules/_expandCollapse');
require('./modules/_floatingButton');
require('./modules/_hm02-heroUserTaskNav');
require('./modules/_horizontalFilterBarDesktopMobile');
require('./modules/_insights-filters-panel');
require('./modules/_linkIcons');
require('./modules/_m01-globalHeader');
require('./modules/_m01-globalHeaderPortal');
require('./modules/_m58-multilingual-panel');
require('./modules/_m59-mobile-multilingual-modal');
require('./modules/_map');
require('./modules/_micrositeHeroBanner');
require('./modules/_modal');
require('./modules/_readSpeakerHandler');
require('./modules/_responsive-table');
require('./modules/_responsiveIframe');
require('./modules/_responsiveLayout');
require('./modules/_search');
require('./modules/_tabs');
require('./modules/_togglePopover');
require('./modules/_tooltips');
require('./modules/_video');
require('./modules/analytics');
require('./modules/forms/_contact-us-form');
require('./modules/forms/_decorator');
require('./modules/forms/_elementTracker');
require('./modules/forms/_feedback-form');
require('./modules/forms/_multistep');
require('./modules/forms/_sync');
require('./modules/forms/_validate');
require('./modules/forms/multistep/_liveform');
require('./modules/forms/multistep/_liveFormAccordion');
require('./modules/forms/multistep/_liveformOnePage');
require('./modules/forms/multistep/_liveformWizard');
require('./modules/forms/multistep/_progressBar');
require('./modules/forms/multistep/_router');
require('./modules/forms/multistep/_service');
require('./modules/forms/multistep/_step');
require('./modules/forms/rules/_cc-cvv');
require('./modules/forms/rules/_cc-expiry');
require('./modules/forms/rules/_cc-number');
require('./modules/forms/rules/_no_digits');
require('./modules/forms/rules/_no_letters');
require('./modules/forms/rules/_required');
require('./modules/nav/_navOffscreen');
require('./modules/nav/_navOnscreen');


require('./qlik-loader');
